import { render, staticRenderFns } from "./RsSurveyStart.vue?vue&type=template&id=8a15ba8c&scoped=true"
import script from "./RsSurveyStart.vue?vue&type=script&lang=js"
export * from "./RsSurveyStart.vue?vue&type=script&lang=js"
import style0 from "./RsSurveyStart.vue?vue&type=style&index=0&id=8a15ba8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a15ba8c",
  null
  
)

export default component.exports